'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _templateObject = _taggedTemplateLiteral(['\n  position: absolute;\n  top: ', ';\n  left: 50%;\n  transform: ', ' translateX(-50%) scale(1.2);\n  z-index: 1000000000000000000000000;\n\n  ', ';\n'], ['\n  position: absolute;\n  top: ', ';\n  left: 50%;\n  transform: ', ' translateX(-50%) scale(1.2);\n  z-index: 1000000000000000000000000;\n\n  ', ';\n']);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _polished = require('polished');

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _taggedTemplateLiteral(strings, raw) {
  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}

var animation = function animation(_ref) {
  var status = _ref.status;

  switch (status) {
    case 'show':
      return 'translateY(-50%)';
    // case 'glide':
    //   return `translateY(calc(-50% + 50px))`

    case 'launch':
      return 'translateY(-300px)';

    default:
      return 'translateY(200px)';
  }
};

var Ship = _styledComponents2.default.div(_templateObject, function (_ref2) {
  var status = _ref2.status;
  return !!status ? '50%' : '200%';
}, animation, (0, _polished.transitions)('transform .5s ease-in-out'));

exports.default = Ship;